import React from 'react';

const Howitworkspopup = () => {
  return (
    <section className="bg-[#0D2B36] text-gray-300 p-8 max-h-[80vh] overflow-y-auto rounded-lg">
      <div className="max-w-4xl mx-auto space-y-4 text-black">
        <p className="text-base text-white text-justify">
          Let us demonstrate through an example:
        </p>

        <div className="space-y-4">
          <div className="pl-4">
            <h3 className="font-semibold text-green-400 text-base underline mb-2">Step 1</h3>
            <p className="text-base text-white text-justify">
              Person ‘P’ from Company ‘ABC’ visits the Ethosflo platform looking for a solution to assess sustainability
              maturity of 30 major suppliers on ESG (environmental, social, governance) issues. ‘P’ signs up on the
              platform with their corporate mail ID and provides details of the 30 suppliers’ contact persons and corporate
              email IDs.
              <br />
              <span className="text-sm text-white italic">
                Please note that the present version of the platform does not provide a login to Company ABC for tracking
                business partner assessment status. Such information can be availed via email communication with the Ethosflo
                account manager.
              </span>
            </p>
          </div>

          <div className="pl-4">
            <h3 className="font-semibold text-green-400 text-base underline mb-2">Step 2</h3>
            <p className="text-base text-justify text-white">
              Ethosflo team immediately sends email to each of the 30 suppliers with a link to sign up for the assessment,
              timelines, and such information. Suppose ’X1’, the contact person of ‘Supplier1’ is one such person who
              received the link
              <br />
              <span className="text-sm text-white italic">
                Please note that Ethosflo team will communicate with only one email ID for each of the assessee or company
                i.e. one point of contact with Supplier1 (‘ X1’) and one point of contact with Company ABC (Person ‘P’). So,
                the email IDs entered by Person P becomes the default contact email, unless modified through communication
                with Ethosflo account manager.
              </span>
            </p>
          </div>

          <div className="pl-4">
            <h3 className="font-semibold text-green-400 text-base underline mb-2">Step 3</h3>
            <p className="text-base text-white  text-justify">
              After successful sign up on the Ethosflo platform, X1 will receive another email with the platform login
              credentials and payment instructions for the assessment.
            </p>
          </div>

          <div className="pl-4">
            <h3 className="font-semibold text-green-400 text-base underline mb-2">Step 4</h3>
            <p className="text-base text-white  text-justify">
              After payment is made X1 will login to the platform using the credentials and enter the payment information.
              After entering the details, X1 can access the questionnaire for the assessment and his progress dashboard. At
              this stage, a dedicated account manager from Ethosflo is assigned to Supplier1 to support the entire process
              (details shared via email with X1).
            </p>
          </div>

          <div className="pl-4">
            <h3 className="font-semibold text-green-400 text-base underline mb-2">Step 5</h3>
            <p className="text-base text-white  text-justify">
              X1 fills in the responses to the questions along with supporting documents, using the guidance provided and
              with additional support from the assigned account manager whenever required. The platform auto-saves the
              progress allowing users to submit the response in phases. At any point X1 can access his dashboard to check
              information such as no. of questions answered, no. of questions pending response, due date for submission,
              document storage utilized, etc.
              <span className="text-sm text-white italic">
                <br />
                Please note that for each assessment, the assessee needs to upload supporting evidence (documents, website
                links, etc) in accordance with the guidance. A total storage of 50MB is allocated for the assessment, per
                assessee, and all documents uploaded should collectively stay within this limit. Thus, we strongly encourage
                ensuring no duplicate uploads.
              </span>
            </p>
          </div>

          <div className="pl-4">
            <h3 className="font-semibold text-green-400  text-base underline mb-2">Step 6</h3>
            <p className="text-base text-white  text-justify">
              On completing the response to the questions along with supporting evidences, X1 submits the assessment for
              scoring.
            </p>
          </div>

          <div className="pl-4">
            <h3 className="font-semibold text-green-400  text-base underline mb-2">Step 7</h3>
            <p className="text-base text-white text-justify">
              Ethosflo team assesses the response and generates an assessment report (along with corrective action plan).
              Once the assessment report is available on website, X1 (from Supplier1) and ‘P’ (from Company ABC who procures
              from Supplier1), each gets an email notification with Supplier1’s assessment report attached. The report is
              valid for 365 days from the day of generation on the website. [Person ‘P’ will get 30 assessment reports, one
              for each supplier assessed.]
              <br />
              <span className="text-sm text-white italic">
                Please note that Supplier1 can have multiple companies who requested them to undertake the assessment through
                Ethosflo. In such cases, the assessment report will be sent to all the interested companies without requiring
                Supplier1 to undertake multiple assessments. Again, if Company ABC is itself a supplier to another company,
                Company XYZ, then they will follow the same procedure outlined above. That is, Company ABC will need to sign
                up separately as an assessee and their assessment report will be sent to Company XYZ’s contact person.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Howitworkspopup;